import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useEnvironment } from 'contexts/environment'
import { Section, Heading, ExternalLink } from '../s'
import Paragraph from 'components/typography/paragraph'

const NetvisorImportantInformation = () => {
    const { environment } = useEnvironment()

    return (
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_netvisor_heading_important_information"
                    defaultMessage="Important information to the Payroll clerk" />
            </Heading>
            <Paragraph>
                <FormattedMessage
                    id="integration_netvisor_preamble_important_information"
                    defaultMessage="Before starting to use the integration make sure the payroll clerk <link>get this information in our Knowledge Base</link>."
                    values={{
                        link: chunks => (
                            <ExternalLink href={`http://www.${environment.tld}/knowledge/integrations/netvisor#important-information`}>
                                {chunks}
                            </ExternalLink>
                        )
                    }} />
            </Paragraph>
        </Section>
    )
}

export default NetvisorImportantInformation